<template>
  <div>
    <div style="text-align:right;" class="pa-2 pb-0 mr-4 mt-2">
      <v-btn class="right" color="green" dark @click="start_payment()"
        >Uplati</v-btn
      >
    </div>
    <v-data-table
      class="ml-4 mr-4"
      :items="items"
      :headers="headers"
      disable-pagination
      hide-default-footer
      no-data-text="Podaci ne postoje za odabranu kategoriju"
    >
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn plain @click="open_invoice(item)">
          <v-icon>mdi-open-in-new</v-icon>
        </v-btn>
      </template>
      <template v-slot:[`item.datum`]="{ item }">
        {{ $moment(item.datum).format("DD.MM.YYYY") }}
      </template>
      <template v-slot:[`item.description`]="{ item }">
        SABIRA mjesečni račun za {{ $moment(item.datum).format("MM YYYY") }}
      </template>
    </v-data-table>
    <sabira_license close="close_payment_dialog" :visible="show_payment">
    </sabira_license>
    <sabira_invoice
      v-if="active_invoice !== null"
      close="invoice_close"
      :invoice_id="active_invoice !== null ? active_invoice.id : null"
    ></sabira_invoice>
  </div>
</template>

<script>
export default {
  components: {
    sabira_license: () => import("@/components/buy_license"),
    sabira_invoice: () => import("@/components/service_invoice"),
  },
  data() {
    return {
      show_payment: false,
      is_loading: false,
      active_invoice: null,
      items: [],
      headers: [
        { text: "Broj fakture", value: "broj", width: 120 },
        { text: "Datum", value: "datum", width: 100 },
        { text: "Usluga", value: "description" },
        { text: null, value: "actions", width: 100 },
      ],
    };
  },
  methods: {
    open_invoice(item) {
      this.active_invoice = item;
    },
    start_payment() {
      this.show_payment = true;
    },
    setup_event_listeners() {
      this.$webpageEventBus.$on("invoice_close", () => {
        this.active_invoice = null;
      });
      this.$webpageEventBus.$on("close_payment_dialog", () => {
        this.$helpers
          .load_user_profile()
          .then(() => {
            this.show_payment = false;
            this.get_invoices();
          })
          .catch((e) => {
            this.$webpageEventBus.$emit("show_status", {
              type: "error",
              message: e.message,
              timeout: 4000,
            });
          });
      });
    },
    close_event_listeners() {
      this.$webpageEventBus.$off("close_payment_dialog");
    },
    get_invoices() {
      this.is_loading = true;
      this.$http({
        method: "POST",
        url: "/fakture/get_client_invoices",
        data: {
          client_id: this.$store.getters.user.klijent_id,
        },
      })
        .then((resp) => {
          this.items = resp.data;
        })
        .catch((e) => {
          alert(e);
        })
        .finally(() => {
          this.show_payment = false;
        });
    },
  },
  mounted() {
    this.get_invoices();
    this.setup_event_listeners();
  },
  destroyed() {
    this.close_event_listeners();
  },
};
</script>
